import React, { useEffect, useState } from 'react'
import { Checkbox, Dropdown, Input } from 'semantic-ui-react'
import { useDebounce } from 'use-lodash-debounce'
import { FiltersWrapper } from '../style'
import { useTranslation } from 'react-i18next'
import { StoneXFiltersType } from '.'
import { StoneXOptions } from '~/QueryHooks/FutureContractsQuery'
import { CheckboxStoneXElement, InputStoneXElement, SelectStoneXElement, StoneXCheckedFilterType } from '~/Constants'

interface FilterProps {
  dataFiltered: StoneXFiltersType,
  onChangeDataFiltered: (dataFiltered: StoneXFiltersType) => void
  filterOptions: StoneXOptions
  checkedFilters: StoneXCheckedFilterType[]
}

type SearchFiltersType = {
  search: string;
  contractNoFrom: string;
  contractNoTo: string;
  priceFrom: string;
  priceTo: string;
};

const Filters: React.FC<FilterProps> = (props) => {
  const { t } = useTranslation()
  const { dataFiltered, onChangeDataFiltered, filterOptions, checkedFilters } = props
  const [inputFilterValues, setInputFilterValues] = useState<SearchFiltersType>({
    search: '',
    contractNoFrom: '',
    contractNoTo: '',
    priceFrom: '',
    priceTo: ''
  })
  const debouncedValues = useDebounce<SearchFiltersType>(inputFilterValues, 300)

  useEffect(() => {
    const inputCompareVal = {}
    Object.keys(debouncedValues).map(key => inputCompareVal[key] = dataFiltered[key])
    if (JSON.stringify(debouncedValues) !== JSON.stringify(inputCompareVal)) {
      onChangeDataFiltered({ ...dataFiltered, ...debouncedValues, page: 0 })
    }
  }, [debouncedValues])

  function renderInputFilter(stoneXFilter: InputStoneXElement) {
    const { placeholder, key } = stoneXFilter
    return <Input
      key={key}
      icon={stoneXFilter?.icon}
      placeholder={t(placeholder)}
      value={inputFilterValues[key]}
      onChange={(e, data) => setInputFilterValues({ ...inputFilterValues, [key]: data.value })}
    />
  }

  function renderSelectFilter(stoneXFilter: SelectStoneXElement) {
    const { placeholder, key, optionsKey } = stoneXFilter
    return <Dropdown
      key={key}
      placeholder={t(placeholder)}
      value={dataFiltered[key]}
      options={filterOptions[optionsKey]?.map(option =>
        ({ value: option.id || option.key, text: stoneXFilter?.labelKey ? option[stoneXFilter?.labelKey] : option.label }))}
      clearable
      selection
      selectOnBlur={false}
      onChange={(e, data) => onChangeDataFiltered({ ...dataFiltered, [key]: data.value })}
    />
  }

  function renderCheckboxFilter(stoneXFilter: CheckboxStoneXElement) {
    return <Checkbox
      label={t(stoneXFilter.label)}
      value={dataFiltered[stoneXFilter.key]}
      onChange={(e, data) => onChangeDataFiltered({ ...dataFiltered, [stoneXFilter.key]: data.checked ? 1 : 0 })}
    />
  }

  function renderFilters() {
    return checkedFilters.map(stoneXFilter => {
      switch (stoneXFilter.type) {
        case 'input':
          return renderInputFilter(stoneXFilter)
        case 'select':
          return renderSelectFilter(stoneXFilter)
        case 'checkbox':
          return renderCheckboxFilter(stoneXFilter)
        default:
          return <></>
      }
    })
  }

  return <FiltersWrapper>
    {renderFilters()}
  </FiltersWrapper>
}
export default Filters